//EbookStore
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebaseConfig";
import PreviewCard from "../previewCard/PreviewCard";
import axios from "axios";
import FeedbackModal from "./FeedbackModal";
import { themeContext } from "../../Context";
import slugify from "slugify"; // install via npm i slugify

export const ebooks = [
    //https://drive.google.com/file/d/1zg9AbzOy3xe2-GMbJIh-tmWRa01bl7GO/view?usp=sharing
    {
        id: 125,
        name: "गुलाम वंश(Slave Dynasty) by @talk_sprint in Hindi | HISTORY",
        price: 5,
        description: "गुलाम वंश(Slave Dynasty) by @talk_sprint in HINDI ",
        image: ["https://i.postimg.cc/pdgrcVx1/image-2025-11-29-173809331.png", "https://i.postimg.cc/q7GDjq2F/image-2025-11-29-174142615.png"],
        downloadLink: "https://drive.google.com/file/d/1cFP7kGLKORfIr3mlgEVTxD4JaVXmixt7/view?usp=sharing",
        // previewLink: "https://drive.google.com/file/d/1_XkAt6Y0hkpp2cgpz3fNTHjD8uYg0MaD/view?usp=sharing"
    },
    {
        id: 124,
        name: "Flowchart for Festivals of India | STATIC",
        price: 5,
        description: "Complete Flowchart for Festivals of India English | STATIC",
        image: ["https://i.postimg.cc/zGXd0t1V/image-2025-11-11-190052376.png", "https://i.postimg.cc/DZjf4YFM/image-2025-11-11-190531133.png", "https://i.postimg.cc/Xvx4tDZj/image-2025-11-11-190614859.png"],
        downloadLink: "https://drive.google.com/file/d/1lPRp5jTXNZz-muAkd_gEw5zL3maO1L6X/view?usp=sharing",
        // previewLink: "https://drive.google.com/file/d/1_XkAt6Y0hkpp2cgpz3fNTHjD8uYg0MaD/view?usp=sharing"
    },
    {
        id: 123,
        name: "Complete Flowchart for Folk Dances of India",
        price: 5,
        description: "Complete Flowchart for Folk Dances of India English",
        image: ["https://i.postimg.cc/DfHSFTMD/image-2025-11-03-205407211.png", "https://i.postimg.cc/YSCgnw0p/image-2025-11-03-205503104.png"],
        downloadLink: "https://drive.google.com/uc?export=download&id=1tkhPbE9oguHnIzKiS9moERCDU3uQ8lmi",
        previewLink: "https://drive.google.com/file/d/1_XkAt6Y0hkpp2cgpz3fNTHjD8uYg0MaD/view?usp=sharing"
    },
    {
        id: 122,
        name: "Indian Musical Instruments Flowchart",
        price: 5,
        description: "Complete Indian Musical Instruments Flowchart English",
        image: ["https://i.postimg.cc/C1w2rjVh/image-2025-10-29-182040272.png"],
        downloadLink: "https://drive.google.com/uc?export=download&id=1LgdeFS1xov3I1nEA9dAwAOGFC8AHAZOC",
        previewLink: "https://drive.google.com/file/d/1vvYLfHXTygxwqxcWEw8RBydF10dMvBPL/view?usp=sharing"
    },
    {
        id: 121,
        name: "DELHI POLICE PYQ practice set4 Talk Sprint",
        price: 5,
        description: "DELHI POLICE PYQ practice set4 Talk Sprint in HINDI",
        image: ["https://i.postimg.cc/zB98rHT9/image-2025-10-27-094949417.png"],
        downloadLink: "https://drive.google.com/file/d/1HUn0W9EhnwcMs2v9v2M296XzcLseSnX2/view?usp=sharing",
        previewLink: "https://drive.google.com/file/d/1Bw02PTdn_mBc6usIZbtytSCh-YGtzrC_/view?usp=sharing"
    },
    {
        id: 119,
        name: "SSC STENO 2025 COMPLETE CURRENT AFFAIR ANALYSIS",
        price: 10,
        description: "SSC STENO 2025 COMPLETE CURRENT AFFAIR ANALYSIS CATEGORY IN FLOWCHART FORM",
        image: ["https://i.postimg.cc/D0th9Fzz/image-2025-09-21-210821254.png", "https://i.postimg.cc/QCWGkPqZ/image-2025-09-21-210914792.png"],
        downloadLink: "https://drive.google.com/file/d/1zg9AbzOy3xe2-GMbJIh-tmWRa01bl7GO/view?usp=sharing"
    },
    {
        id: 120,
        name: "PREP RADAR September Month Current Affairs By Talk Sprint in HINDI",
        price: 10,
        description: "PREP RADAR September Month Current Affairs By Talk Sprint in HINDI",
        image: ["https://i.postimg.cc/kXm5ZMTk/image-2025-10-20-165903933.png", "https://i.postimg.cc/sX4Fqz6m/image-2025-10-20-164654493.png", "https://i.postimg.cc/Gm44Cg1b/image-2025-10-20-165153846.png"],
        downloadLink: "https://drive.google.com/file/d/1T2TA9PdmVlsVHO1gXNyB5C-l-p6I-CJ4/view?usp=sharing",
        previewLink: "https://drive.google.com/file/d/1lukE9WCIQHtkZwXqQDd8apdPdjw1PD1k/view?usp=sharing"
    },
    // {
    //     id: 1,
    //     name: "SSC CGL General Awareness PYQ 2024",
    //     price: 20,
    //     description: "Complete SSC CGL General Awareness 2024 TopicWise Questions.",
    //     image: "https://i.imgur.com/8qS0n1C_d.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1Ku_j3cFvnVaf5lFDGU3bXsvPl4S00bY_/view?usp=sharing"
    // },
    // {
    //     id: 2,
    //     name: "SSC CHSL General Awareness PYQ 2024.",
    //     price: 10,
    //     description: "Complete SSC CHSL General Awareness 2024 TopicWise Questions.",
    //     image: "https://i.imgur.com/jCA9KUo_d.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1--KQovmQ8WXq87_RbNlKspQ7fFOyIoNh/view?usp=sharing"
    // },
    // {
    //     id: 3,
    //     name: "SSC GD General Awareness PYQ 2024.",
    //     price: 10,
    //     description: "Complete SSC GD General Awareness 2024 TopicWise Questions.",
    //     image: "https://i.imgur.com/nXRZuYM_d.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1-8U0mSiqU814blPXcHGTfWdBb7u9Levf/view?usp=sharing"
    // },
    // {
    //     id: 4,
    //     name: "SSC CPO General Awareness PYQ 2024.",
    //     price: 10,
    //     description: "Complete SSC CPO General Awareness 2024 TopicWise Questions.",
    //     image: "https://i.imgur.com/9H4CGnt.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1-1ec3N8bfvEQU1jUMX0FNAMbdRM12xPL/view?usp=sharing"
    // },
    // {
    //     id: 33,
    //     name: "SSC MTS General Awareness PYQ 2024.",
    //     price: 10,
    //     description: "Complete SSC MTS General Awareness 2024 TopicWise Questions.",
    //     image: "https://i.imgur.com/efWkgIo_d.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1Y_V04I4BMoZ6nNVOjQIIJdlIxr7HIOZA/view?usp=sharing"
    // },
    // {
    //     id: 116,
    //     name: "SSC CGL General Awareness PYQ 2024 HINDI",
    //     price: 20,
    //     description: "SSC CGL 2024 TIER-1 Complete General Awareness in Hindi",
    //     image: "https://i.postimg.cc/fWSycKkm/image-2025-05-09-183554352.png",
    //     downloadLink: "https://drive.google.com/file/d/1V495iQWhJywF-FJgb6mmxz-7nkEhXV64/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/1s2k5bjHVRKwIq-DddS4zc-KTsSUCGfIV/view?usp=sharing",
    //     category: "static"
    // },
    // {
    //     id: 117,
    //     name: "SSC CGL ENGLISH TOPICWISE PYQ 2024",
    //     price: 20,
    //     description: "SSC CGL ENGLISH TOPICWISE PYQ 2024",
    //     image: "https://i.postimg.cc/vZV4TY9R/image-2025-05-09-201733889.png",
    //     downloadLink: "https://drive.google.com/file/d/1pz0_vznX5kg050Of1wZ35Ooe1YvS2GXk/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/1FOMbrIBGXm4oQHu4ZRWOswPzKR2OfqVk/view?usp=sharing",
    //     category: "english"
    // },
    // {
    //     id: 21,
    //     name: "COMPLETE STATIC GK ENGLISH BY PARMAR SIR 2025.",
    //     price: 20,
    //     description: "COMPLETE STATIC GK ENGLISH BY PARMAR CLASSES 2025.",
    //     image: "https://i.imgur.com/0Q9IRzS.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1H6nL3Lu8J4sms2ps16K9S7I91jMysb2-/view?usp=sharing"
    // },
    // {
    //     id: 22,
    //     name: "COMPLETE STATIC GK HINDI BY PARMAR SIR 2025.",
    //     price: 20,
    //     description: "COMPLETE STATIC GK HINDI BY PARMAR CLASSES 2025..",
    //     image: "https://i.imgur.com/uUjK6HI.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1Njbh7Tw7Hq4l0-FsrGWBYWEr3HIfZAW6/view?usp=sharing"
    // },
    // {
    //     id: 46,
    //     name: "COMPLETE ANCIENT HISTORY ENGLISH BATCH 3 PARMAR SIR 2025.",
    //     price: 20,
    //     description: "COMPLETE ANCIENT HISTORY BATCH 3 2025 BY PARMAR CLASSES.",
    //     image: "https://i.imgur.com/bsZjyvK.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1BmyjwlqeBYrC8cPIDaesaqWA6I68GBDd/view?usp=sharing"
    // },
    // {
    //     id: 47,
    //     name: "COMPLETE ANCIENT HISTORY HINDI BATCH 3 PARMAR SIR 2025.",
    //     price: 20,
    //     description: "COMPLETE ANCIENT HISTORY HINDI BATCH 3 2025 BY PARMAR CLASSES.",
    //     image: "https://i.imgur.com/aTx4zAm.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1e1TPuh_xHQ8n6SvFOc8MjWXddMyYzNvV/view?usp=sharing"
    // },
    // {
    //     id: 68,
    //     name: "COMPLETE MEDIEVAL HISTORY ENGLISH BATCH 3 PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE MEDIEVAL HISTORY ENGLISH BATCH 3 2025",
    //     image: "https://i.imgur.com/p9REZRh.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1qe8Pne-htEqPsQl2qwpMhU8sctSnWK2Q/view?usp=sharing"
    // },
    // {
    //     id: 69,
    //     name: "COMPLETE MEDIEVAL HISTORY HINDI BATCH 3 PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE MEDIEVAL HISTORY HINDI BATCH 3 2025",
    //     image: "https://i.imgur.com/8wDsIA2.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1FU5gK0suK6Z7ctZ7X4xFVVlPRaSgRyQm/view?usp=sharing"
    // },
    // {
    //     id: 96,
    //     name: "COMPLETE MORDERN HISTORY ENGLISH BATCH 3 PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE MORDERN HISTORY ENGLISH BATCH 3 2025",
    //     image: "https://i.imgur.com/myuImGu.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1pdlMu-9OHSrr7rb_MCzH7t7X424oeXbV/view?usp=sharing"
    // },
    // {
    //     id: 97,
    //     name: "COMPLETE MORDERN HISTORY HINDI BATCH 3 PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE MORDERN HISTORY HINDI BATCH 3 2025",
    //     image: "https://i.imgur.com/UAvhuqb.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1gQTa7CbKx6mF9u9SMtY-gKwAUI9WOChN/view?usp=sharing"
    // },
    // {
    //     id: 82,
    //     name: "COMPLETE GEOGRAPHY ENGLISH PARMAR SIR 2025 BATCH 3 ",
    //     price: 25,
    //     description: "Complete Geography English Parmar BATCH 3 2025",
    //     image: "https://i.imgur.com/rqQex6E.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1xvJ27NkHLo5EkxWDnX1a5-krAgaSap4B/view?usp=sharing"
    // },
    // {
    //     id: 84,
    //     name: "COMPLETE GEOGRAPHY HINDI BATCH 3 PARMAR SIR 2025",
    //     price: 25,
    //     description: "Complete Geography Hindi Parmar BATCH 3 2025",
    //     image: "https://i.imgur.com/dcp98fy.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1GwRtDAb5Dm-QKXpQoR3MoLi06tSyo1Fi/view?usp=sharing"
    // },
    // {
    //     id: 88,
    //     name: "COMPLETE ECONOMICS ENG PARMAR SIR 2025 CLASSES BATCH 3",
    //     price: 15,
    //     description: "ECONOMICS ENG PARMAR CLASSES BATCH 3 LEC 1-10",
    //     image: "https://i.imgur.com/FRVj4if.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1ijJpmYVcizI2IfCD5pMHNCfYipqqM0ZE/view?usp=sharing"
    // },
    // {
    //     id: 89,
    //     name: "COMPLETE ECONOMICS HINDI PARMAR SIR 2025 CLASSES BATCH 3",
    //     price: 15,
    //     description: "ECONOMICS HINDI PARMAR CLASSES BATCH 3 LEC 1-10",
    //     image: "https://i.imgur.com/xwNCbsp.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/14UdhjZ2336C625oLLq7CNVkiBY3SUZXJ/view?usp=sharing"
    // },
    // {
    //     id: 90,
    //     name: "COMPLETE PHYSICS BATCH 3 ENGLISH PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE PHYSICS ENGLISH PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/WKiW2aw.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/180jRbROyq9b4eiwIi-CVpRq-9GsPMtJx/view?usp=sharing"
    // },
    // {
    //     id: 91,
    //     name: "COMPLETE PHYSICS BATCH 3 HINDI PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE PHYSICS HINDI PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/uh7PEsu.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1h1mxrknypKQ6Zm0SuMPfMWj5ImtnZeQM/view?usp=sharing"
    // },
    // {
    //     id: 92,
    //     name: "COMPLETE BIOLOGY BATCH 3 ENGLISH PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE BIOLOGY ENGLISH PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/HiY6Z5B.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1Mj8TH7ckr1lvXHVSBtlXAppwOWuMdt5n/view?usp=sharing"
    // },
    // {
    //     id: 93,
    //     name: "COMPLETE BIOLOGY BATCH 3 HINDI PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE BIOLOGY HINDI PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/77NMVEp.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1jqTU7WM3c46werIafdp-VHiqRCxD3tfJ/view?usp=sharing"
    // },
    // {
    //     id: 94,
    //     name: "COMPLETE CHEMISTRY BATCH 3 ENGLISH PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE CHEMISTRY ENGLISH PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/yLkgjpu.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1rChQ7LkxJMMkuyjR-RfwQJsctmI9G7Ck/view?usp=sharing"
    // },
    // {
    //     id: 95,
    //     name: "COMPLETE CHEMISTRY BATCH 3 HINDI PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE CHEMISTRY HINDI PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/6Goclwh.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1IIDotv70xNAhOtxW4dOkkAo3ZM6Xx7Mn/view?usp=sharing"
    // },
    // {
    //     id: 98,
    //     name: "COMPLETE POLITY BATCH 3 ENGLISH PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE POLITY ENGLISH PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/dsVzTOT.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1AxE9uneoybcezExncIg-N_FGwaFRk8gO/view?usp=sharing"
    // },
    // {
    //     id: 99,
    //     name: "COMPLETE POLITY BATCH 3 HINDI PARMAR SIR 2025",
    //     price: 20,
    //     description: "COMPLETE POLITY HINDI PARMAR CLASSES BATCH 3 2025",
    //     image: "https://i.imgur.com/8mbzDy1.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1M3nir2LhdRxmII3GVxEHmSPRrBkTWVWk/view?usp=sharing"
    // },
    {
        id: 13,
        name: "Computer 1500+ Previous Year SSC & TCS Questions",
        price: 10,
        description: "Complete 1500+ Previous Year for SSC & TCS Questions",
        image: "https://i.imgur.com/Vf1NCjk.png?maxwidth=520&shape=thumb&fidelity=low",
        downloadLink: "https://drive.google.com/file/d/1XVBEe-jCCyU-OGDYXy8swMJCcqLhR99C/view?usp=sharing",
        previewLink: "https://drive.google.com/file/d/1XtcMCL7qHEsbiQR9C7EYs-ugEsP3_t4M/view?usp=drive_link"
    },
    {
        id: 101,
        name: "Indian Folk Dance Static Flowchart",
        price: 5,
        description: "Indian Folk Dance StaticGK Flowchart",
        image: "https://i.imgur.com/pEkNICM.png?maxwidth=520&shape=thumb&fidelity=low",
        downloadLink: "https://drive.google.com/uc?export=download&id=1BYJY23HW6DO2vCk5FZdEC2OyL3DPHQ7_"
    },
    // {
    //     id: 102,
    //     name: "Parmar Complete English Mindmaps | PARMAR SIR | All Subjects",
    //     price: 30,
    //     description: "Complete English Mindmaps for Geography, Civics, History, Biology, Economics",
    //     image: "https://i.imgur.com/7V91kx0.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1PD_MEkQGO5DMUbldcETCRtqM15fa4h30/view?usp=sharing"
    // },
    // {
    //     id: 103,
    //     name: "Complete Hindi Mindmaps | PARMAR SIR | All Subjects",
    //     price: 30,
    //     description: "Complete Hindi Mindmaps for Geography, Civics, History, Biology, Economics",
    //     image: "https://i.imgur.com/SKVNGU8.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1PE8XglyC5sOqsvQEqcJQkKSIMwH96hgI/view?usp=sharing"
    // },
    {
        id: 104,
        name: "COMPUTER SOLVED PAPERS CHAPTERWISE | ENGLISH | FOR ALL EXAMS",
        price: 40,
        description: "COMPUTER PLANNER Chapterwise Solved Paper",
        image: "https://i.imgur.com/R1GIPbP.png?maxwidth=520&shape=thumb&fidelity=low",
        downloadLink: "https://drive.google.com/file/d/1lizqMHKzD3yEz-ysFsJnhhY1CNgWwLIr/view?usp=sharing",
        previewLink: "https://drive.google.com/file/d/1CClHgtHjj3Xrz8uvJrs1-ZKzJUBr6xYk/view?usp=drive_link" // Will show preview
    },
    // {
    //     id: 105,
    //     name: "JANUARY MONTH 2025 ENGLISH MAGZINE PARMAR SSC",
    //     price: 20,
    //     description: "JANUARY 2025 MONTH MAGZINE PARMAR SSC ENGLISH CURRENT AFFAIRS",
    //     image: "https://i.imgur.com/jgJPrQt.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1W9_BFcDTpdP4xbM0WqS7yPPBD48N10lF/view?usp=sharing"
    // },
    // {
    //     id: 106,
    //     name: "FEBRUARY MONTH 2025 ENGLISH MAGZINE PARMAR SSC",
    //     price: 20,
    //     description: "FEBRUARY 2025 MONTH MAGZINE PARMAR SSC ENGLISH CURRENT AFFAIRS",
    //     image: "https://i.imgur.com/7FCy6he.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1xdqbmAe0NV7td6yYSq51siDqn8ex4h9u/view?usp=sharing"
    // },
    // {
    //     id: 107,
    //     name: "MARCH MONTH 2025 ENGLISH MAGZINE PARMAR SSC",
    //     price: 20,
    //     description: "MARCH 2025 MONTH MAGZINE PARMAR SSC ENGLISH CURRENT AFFAIRS",
    //     image: "https://i.imgur.com/h5NAfX0.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1m5sKB7kewZ_bz3KaOnOxAThysVETDQGH/view?usp=sharing"
    // },
    // {
    //     id: 108,
    //     name: "JANUARY MONTH 2025 HINDI MAGZINE PARMAR SSC",
    //     price: 20,
    //     description: "JANUARY 2025 MONTH MAGZINE PARMAR SSC HINDI CURRENT AFFAIRS",
    //     image: "https://i.imgur.com/jgJPrQt.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1Z0oznctHsNxFGaX-y7CGu3qyQQDfAXGP/view?usp=sharing"
    // },
    // {
    //     id: 109,
    //     name: "FEBRUARY MONTH 2025 HINDI MAGZINE PARMAR SSC",
    //     price: 20,
    //     description: "FEBRUARY 2025 MONTH MAGZINE PARMAR SSC HINDI CURRENT AFFAIRS",
    //     image: "https://i.imgur.com/7FCy6he.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1bQAB5kt3a1fWr49PoOXWoXF3eH3gOwUa/view?usp=sharing"
    // },
    // {
    //     id: 110,
    //     name: "MARCH MONTH 2025 HINDI MAGZINE PARMAR SSC",
    //     price: 20,
    //     description: "MARCH 2025 MONTH MAGZINE PARMAR SSC HINDI CURRENT AFFAIRS",
    //     image: "https://i.imgur.com/h5NAfX0.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/10Hgr_eJjiUfX2K_JALYCVZZU-AScxPx0/view?usp=sharing"
    // },
    // {
    //     id: 111,
    //     name: "BRAHMASTRA Maths Formula Book By Aditya Ranjan",
    //     price: 30,
    //     description: "BRAHMASTRA Maths Formula Book By Aditya Ranjan",
    //     image: "https://i.imgur.com/PT2QHe1.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1_eDjQ_orGVyB6Guwl9NE7l3Wt827kOsL/view?usp=drive_link",
    //     previewLink: "https://drive.google.com/file/d/1ec7ScLRFBmxZYqeI8Qrt4o4RZ1ZwDJ__/view?usp=sharing",
    //     category: "maths"
    // },
    // {
    //     id: 112,
    //     name: "BRAHMASTRA Maths Formula Book By Aditya Ranjan 2nd Edition",
    //     price: 40,
    //     description: "Maths Formula Book By Aditya Ranjan  2nd Edition",
    //     image: "https://i.imgur.com/F8ks1Ke.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1RrvGiCeNsJzzXUsjRnshlaEkyJalNHn0/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/15GAYYNKhMEO0fDtqCb4BM_Xrotajpq_g/view?usp=sharing",
    //     category: "maths"
    // },
    // {
    //     id: 113,
    //     name: "Maths Concept King Gagan Pratap Sir",
    //     price: 40,
    //     description: "Maths Concept King Gagan Pratap Sir All Formulas & Theorems",
    //     image: "https://i.imgur.com/pYTsDVz.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1RI-OV7DKkACOMtBWvFdYhVDNGN34B_Fb/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/1lya1HhsKvjcnlXHHtG1vOOO76L7Xa2JY/view?usp=sharing",
    //     category: "maths"
    // },
    // {
    //     id: 114,
    //     name: "Viral Maths for Calculations By Navneet Tiwari",
    //     price: 40,
    //     description: "Viral Maths for Calculations By Navneet Tiwari",
    //     image: "https://i.imgur.com/oDTmgYJ.png?maxwidth=520&shape=thumb&fidelity=low",
    //     downloadLink: "https://drive.google.com/file/d/1RcumeYAQEbYyJKDvFEOV1WszMUyBhKMc/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/1fpMBPrQ-8PtSf4PJwpjka7yQtoGmxxvZ/view?usp=sharing",
    //     category: "maths"
    // },
    // {
    //     id: 115,
    //     name: "STATIC GK NAVEEN SIR HINDI NEW ADDITION 2025",
    //     price: 40,
    //     description: "STATIC GK NAVEEN SIR HINDI NEW ADDITION 2025",
    //     image: "https://i.postimg.cc/W3LNT57c/Screenshot-2025-05-01-at-1-06-18-PM.png",
    //     downloadLink: "https://drive.google.com/file/d/1Sp7XgKaAD1JgraFCWexLg3_PnitnizHE/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/1WNuOjeGe1f-d7XCV-dZOiA0jsGHw5Oo9/view?usp=sharing",
    //     category: "static"
    // },
    // {
    //     id: 118,
    //     name: "LEC 1-30 ENGLISH NOTES | ALL COMBINED PYQ LECTURES",
    //     price: 25,
    //     description: "PARMAR SIR LEC 1-30 ENGLISH COMBINED NOTES",
    //     image: "https://i.postimg.cc/B6LP4nNw/image-2025-05-23-023835472.png",
    //     downloadLink: "https://drive.google.com/file/d/1mns-rtpM2s594-ODy70mpcqZ5oCws6t6/view?usp=sharing",
    //     previewLink: "https://drive.google.com/file/d/1abDOyXl6Ftus_s7rloPz-BilTOeq1a8F/view?usp=sharing",
    //     category: "english"
    // }
    //Statr 119
];



const EbookStore = ({ cart, setCart, darkMode }) => {
    const [user, setUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredEbooks, setFilteredEbooks] = useState(ebooks);
    const [showRecommendations, setShowRecommendations] = useState(false);
    const [activeFilter, setActiveFilter] = useState("All");
    const recommendedSearches = ["All", "PYQ 2024", "COMPUTER", "PHYSICS", "CHEMISTRY", "BIOLOGY", "HISTORY", "ECONOMICS", "STATIC GK", "MATHS", "TALK SPRINT", "ENGLISH NOTES"];
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

    const navigate = useNavigate();
    const theme = useContext(themeContext);
    const darkActive = theme.state.darkMode;

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (activeFilter === "All") {
            setFilteredEbooks(ebooks);
        } else {
            const filtered = ebooks.filter(ebook =>
                ebook.name.toLowerCase().includes(activeFilter.toLowerCase())
            );
            setFilteredEbooks(filtered);
        }
        setSearchQuery(""); // Clear search when filter changes
    }, [activeFilter]);

    const addToCart = (ebook) => {
        if (!user) {
            alert("Please login to add items to cart!");
            return;
        }
        if (cart.some((item) => item.id === ebook.id)) {
            alert("This book is already in your cart!");
            return;
        }
        setCart([...cart, ebook]);
        alert(`${ebook.name} added to cart!`);
        // console.log("ebook", ebook);
    };

    // 1. Add this to your cart page (or app initialization)
    useEffect(() => {
        const warmUpServer = async () => {
            try {
                await axios.get('https://cashfree-backend-1k3q.onrender.com/warmup', {
                    timeout: 3000 // Don't wait too long
                });
            } catch (error) {
                console.log('Server warming in background...');
            }
        };
        warmUpServer();
    }, []);



    return (
        <div style={{ padding: "20px", marginBottom: "50vh" }}>
            <h2 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>
                E-Books Store 📚
            </h2>
            {/* Category filter chips */}
            <div style={styles.filterContainer}>
                {recommendedSearches.map((filter) => (
                    <button
                        key={filter}
                        onClick={() => setActiveFilter(filter)}
                        style={{
                            ...styles.filterButton,
                            ...(activeFilter === filter ? styles.activeFilter : {})
                        }}
                    >
                        {filter}
                    </button>
                ))}
            </div>
            <div style={styles.searchContainer}>
                <input
                    type="text"
                    placeholder="Search ebooks..."
                    value={searchQuery}
                    onChange={(e) => {
                        const query = e.target.value;
                        setSearchQuery(query);
                        const filtered = ebooks.filter(ebook =>
                            ebook.name.toLowerCase().includes(query.toLowerCase())
                        );
                        setFilteredEbooks(filtered);
                        if (query.trim() === '') {
                            setShowRecommendations(true);
                        } else {
                            setShowRecommendations(false);
                        }
                    }}
                    onFocus={() => setShowRecommendations(true)}
                    onBlur={() => setTimeout(() => setShowRecommendations(false), 200)}
                    style={styles.searchInput}
                />
                {showRecommendations && recommendedSearches.length > 0 && (
                    <div style={styles.recommendationsContainer}>
                        {recommendedSearches.map((term, index) => (
                            <div
                                key={index}
                                onClick={() => {
                                    setSearchQuery(term);
                                    const filtered = ebooks.filter(ebook =>
                                        ebook.name.toLowerCase().includes(term.toLowerCase())
                                    );
                                    setFilteredEbooks(filtered);
                                    setShowRecommendations(false);
                                }}
                                style={styles.recommendationItem}
                            >
                                {term}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center', marginBottom: "25px" }}>
                {/* {filteredEbooks.map((ebook) => (
                    <PreviewCard
                        key={ebook.id}
                        card={{
                            id: ebook.id,
                            title: ebook.name,
                            description: ebook.description,
                            image: ebook.image,
                            link: "#",
                        }}
                        darkMode={darkMode}
                        price={ebook.price}
                        size="small"
                        addToCart={() => addToCart(ebook)}
                    />
                ))} */}
                {/* {filteredEbooks.length > 0 ? (
                    filteredEbooks.map((ebook) => (
                        // <Link to={`/ebook/${ebook.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                        <PreviewCard
                            key={ebook.id}
                            card={{
                                id: ebook.id,
                                title: ebook.name,
                                description: ebook.description,
                                image: ebook.image,
                                link: "#",
                                previewLink: ebook.previewLink // Only passed if it exists
                            }}
                            darkMode={darkMode}
                            price={ebook.price}
                            user={user}
                            size="small"
                            addToCart={() => addToCart(ebook)}
                        />
                        // </Link>
                    ))
                ) : (
                    <p>No ebooks found in this category.</p>
                )} */}

                {filteredEbooks.length > 0 ? (
                    filteredEbooks.map((ebook) => {
                        // Create descriptive link
                        const slug = slugify(ebook.name, { lower: true, strict: true });
                        const link = `/ebook/${slug}-${ebook.id}`; // e.g., /ebook/ssc-cgl-general-awareness-pyq-2024-1

                        return (
                            <PreviewCard
                                key={ebook.id}
                                card={{
                                    id: ebook.id,
                                    title: ebook.name,
                                    description: ebook.description,
                                    image: ebook.image,
                                    link: link,
                                    previewLink: ebook.previewLink
                                }}
                                darkMode={darkMode}
                                price={ebook.price}
                                user={user}
                                size="small"
                                addToCart={() => addToCart(ebook)}
                            />
                        );
                    })
                ) : (
                    <p>No ebooks found in this category.</p>
                )}

            </div>

            <div
                style={{
                    position: "fixed",
                    bottom: "15px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "90%",
                    maxWidth: "400px",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                }}
            >
                <button
                    className="button n-button"
                    style={{
                        position: "fixed",
                        bottom: "60px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "70%",
                        maxWidth: "400px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        padding: "10px 20px",
                        // backgroundColor: "#28a745",
                        // color: "#fff",
                        borderRadius: "8px",
                        border: "none",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        zIndex: 9999,
                    }}
                    onClick={() => {
                        setIsFeedbackModalOpen(true);
                    }}>
                    📝 Rating & Reviews
                </button>
                <FeedbackModal
                    isOpen={isFeedbackModalOpen}
                    onRequestClose={() => setIsFeedbackModalOpen(false)}
                    darkMode={darkActive}
                />
                <button
                    style={{
                        flex: 1,
                        backgroundColor: "#28a745",
                        color: "white",
                        padding: "12px",
                        borderRadius: "8px",
                        border: "none",
                        fontSize: "16px",
                        cursor: "pointer",
                        textAlign: "center",
                        fontWeight: "bold",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    }}
                    onClick={() => navigate("/downloads")}
                >
                    📥 My Downloads
                </button>



                <button
                    style={{
                        flex: 1,
                        backgroundColor: cart.length === 0 ? "gray" : "#007bff",
                        color: "white",
                        padding: "12px",
                        borderRadius: "8px",
                        border: "none",
                        fontSize: "16px",
                        cursor: cart.length === 0 ? "not-allowed" : "pointer",
                        textAlign: "center",
                        fontWeight: "bold",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    }}
                    onClick={() => {
                        if (cart.length === 0) {
                            alert("Your cart is empty! Add items before viewing your cart.");
                        } else {
                            navigate("/ecart");
                        }
                    }}
                    disabled={cart.length === 0}
                >
                    🛒 Go to Cart ({cart.length})
                </button>
            </div>
        </div>
    );
};

// const EbookStore = ({cart, setCart, darkMode}) => {
//     const [user, setUser] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const unsubscribe = auth.onAuthStateChanged((currentUser) => {
//             setUser(currentUser);
//         });
//         return () => unsubscribe();
//     }, []);

//     const addToCart = (ebook) => {
//         if (!user) {
//             alert("Please login to add items to cart!");
//             return;
//         }
//         if (cart.some((item) => item.id === ebook.id)) {
//             alert("This book is already in your cart!");
//             return;
//         }
//         setCart([...cart, ebook]);
//         alert(`${ebook.name} added to cart!`);
//     };

//     return (
//         <div style={{ padding: "20px" }}>
//             <h2 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>
//                 E-Books Store 📚
//             </h2>
//             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center', marginBottom: "25px" }}>
//                 {ebooks.map((ebook) => (
//                     <PreviewCard
//                         key={ebook.id}
//                         card={{
//                             id: ebook.id,
//                             title: ebook.name,
//                             description: ebook.description,
//                             image: ebook.image,
//                             link: "#",
//                         }}
//                         darkMode={darkMode}
//                         price={ebook.price}
//                         size="small"
//                         addToCart={() => addToCart(ebook)}
//                     />
//                 ))}
//             </div>

//             {/* <button
//                 className="button n-button"
//                 style={{ marginTop: "20px" }}
//                 onClick={() => {
//                     if (cart.length === 0) {
//                         alert("Your cart is empty! Add items before viewing your cart.");
//                     } else {
//                         navigate("/ecart");
//                     }
//                 }}
//             >
//            {/* ✅ Button Container for My Downloads & Go to Cart */}
//             <div
//                 style={{
//                     position: "fixed",
//                     bottom: "15px",
//                     left: "50%",
//                     transform: "translateX(-50%)",
//                     width: "90%",
//                     maxWidth: "400px",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     gap: "10px",
//                 }}
//             >
//                 {/* ✅ My Downloads Button (Left) */}
//                 <button
//                     style={{
//                         flex: 1,
//                         backgroundColor: "#28a745",
//                         color: "white",
//                         padding: "12px",
//                         borderRadius: "8px",
//                         border: "none",
//                         fontSize: "16px",
//                         cursor: "pointer",
//                         textAlign: "center",
//                         fontWeight: "bold",
//                         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
//                     }}
//                     onClick={() => navigate("/downloads")}
//                 >
//                     📥 My Downloads
//                 </button>

//                 {/* ✅ Go to Cart Button (Right) */}
//                 <button
//                     style={{
//                         flex: 1,
//                         backgroundColor: cart.length === 0 ? "gray" : "#007bff",
//                         color: "white",
//                         padding: "12px",
//                         borderRadius: "8px",
//                         border: "none",
//                         fontSize: "16px",
//                         cursor: cart.length === 0 ? "not-allowed" : "pointer",
//                         textAlign: "center",
//                         fontWeight: "bold",
//                         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
//                     }}
//                     onClick={() => {
//                         if (cart.length === 0) {
//                             alert("Your cart is empty! Add items before viewing your cart.");
//                         } else {
//                             navigate("/ecart");
//                         }
//                     }}
//                     disabled={cart.length === 0}
//                 >
//                     🛒 Go to Cart ({cart.length})
//                 </button>
//             </div>

//         </div>
//     );
// };

const styles = {
    filterContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginBottom: '20px',
    },
    filterButton: {
        padding: '8px 16px',
        borderRadius: '20px',
        border: '1px solid #ddd',
        background: '#f5f5f5',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'all 0.3s ease',
    },
    activeFilter: {
        background: '#007bff',
        color: 'white',
        borderColor: '#007bff',
    },
    searchContainer: {
        // display: "flex",
        display: "none",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        marginBottom: "20px",
        width: "100%",
    },
    searchInput: {
        padding: "12px",
        width: "80%",
        borderRadius: "8px",
        border: "2px solid #007bff",
        fontSize: "16px",
        outline: "none",
        transition: "0.3s",
        boxShadow: "0 2px 5px rgba(0, 123, 255, 0.2)"
    },
    recommendationsContainer: {
        position: "absolute",
        width: "80%",
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
        marginTop: "50px",
        zIndex: 10,
        overflowY: "auto",
        maxHeight: "200px",
    },
    recommendationItem: {
        padding: "12px",
        cursor: "pointer",
        fontSize: "14px",
        borderBottom: "1px solid #f0f0f0",
        transition: "0.3s",
        textAlign: "left",
        color: "#333",
        backgroundColor: "#fff"
    },
    recommendationItemHover: {
        backgroundColor: "#007bff",
        color: "#fff"
    }
};

export default EbookStore;
